<div class="register_class" [ngClass]="{'inc-width': formSteps==3, 'inc-height' : formSteps==4}">

    <div class="closebutton pointer">
        <img (click)="global.trackEvent('Registration', 'Register-Cross');closeDialog()" alt="Close"
            *ngIf="formSteps == 1 || formSteps == 4">
        <img (click)="global.trackEvent('Registration', 'Register-Cross-step-2');closeDialog();verifyEmail()"
            alt="Close" *ngIf="formSteps == 2">
        <img (click)="global.trackEvent('Registration', 'Register-Cross-step-3');closeDialog();verifyEmail()"
            routerLink="/mydashboard" alt="Close" *ngIf="formSteps == 3 && showForm3">
    </div>

    <div class="mpadding">

        <div class="login" id="form1" *ngIf="formSteps==1">
            <div class="header ">Add Your Artist Detail</div>
            <div class="notartist p-b-10">Not an Artist? <a
                    (click)="global.trackEvent('Registration', 'Option-Listner');listner()">Click here</a></div>
            <!-- <div class="iam">
                <form #myform="ngForm" class="m-b-10">

                    <div class="d-flex flex-row justify-content-between">

                        <div class="pt-2 labels">I am a/an</div>
                        <div class="radio">
                            <input id="radio-1" type="radio" value="Artist" name="type" [(ngModel)]="type"
                                (click)="global.trackEvent('Registration', 'Option-Artist');show(true)">
                            <label for="radio-1" class="radio-label">Artist</label>
                        </div>

                        <div class="radio">
                            <input id="radio-2" type="radio" value="Band" name="type" [(ngModel)]="type"
                                (click)="global.trackEvent('Registration', 'Option-Band');show(false)">
                            <label for="radio-2" class="radio-label">Band</label>
                        </div>
                    </div>

                </form>

                <mat-error *ngIf="isFormSubmitted && myForm.invalid" class="f10"
                    style="text-align:left;font-weight: bold;">
                    Please select one
                </mat-error>


            </div> -->


            <!--login form-->
            <form [formGroup]="registerForm" (ngSubmit)="onRegisterFormSubmit()">

                <!--Add your Artist Detail form: PAGE 1-->
                <div class="artistdetail" id="form2">
                    <div class="details">
                        <div class="margin-flex">
                            <div class="m-0 p-0 form-group" style="width: 100%;">
                                <!-- <div class="labels">{{myform.value.type == "" ? "Artist/Band" : myform.value.type ==
                                    "Artist" ? "Stage" : "Band"}} Name*</div>
                                <input
                                    [ngClass]="{ 'is-invalid':(fnamee.dirty || fnamee.touched) && (fnamee.errors?.required || fnamee.errors?.validSongTitle || fnamee.errors?.maxlength)  || (isRegisterFormSubmitted && fnamee.pristine)}"
                                    class="m-0 form-control" type='text' formControlName="fname" placeholder="{{myform.value.type == '' ? 'Artist/Band' : myform.value.type ==
                                    'Artist' ? 'Artist' : 'Band'}} Name" required>

                                <mat-error
                                    *ngIf="(fnamee.touched ||fnamee.dirty)  && fnamee.errors?.required || (isRegisterFormSubmitted && fnamee.pristine)">
                                    Please enter your {{myform.value.type == "" ? "Artist/Band" : myform.value.type ==
                                    "Artist" ? "Artist" : "Band"}} Name
                                </mat-error>
                                <mat-error *ngIf="!fnamee.errors?.required && fnamee.errors?.validSongTitle">
                                    Please enter a valid {{myform.value.type == "" ? "Artist/Band" : myform.value.type
                                    ==
                                    "Artist" ? "Artist" : "Band"}} Name
                                </mat-error>

                                <mat-error
                                    *ngIf="fnamee.errors?.pattern">
                                     Please enter a valid name.
                                </mat-error>

                                <mat-error
                                    *ngIf="isRegisterFormSubmitted && fnamee.errors?.maxlength && !fnamee.errors?.validSongTitle && !fnamee.errors?.required   ">
                                    {{myform.value.type == "" ? "Artist/Band" : myform.value.type == "Artist" ? "Artist"
                                    :
                                    "Band"}} Name can't be more than 50
                                    characters long
                                </mat-error> -->

                                <div class="labels">Artist/ Stage Name*</div>
                                <input
                                    [ngClass]="{ 'is-invalid': (fnamee.errors?.required || fnamee.errors?.validSongTitle || fnamee.errors?.pattern || fnamee.errors?.maxlength)  && isRegisterFormSubmitted}"
                                    class="m-0 form-control" type='text' formControlName="fname"
                                    placeholder="Artist Name" required>

                                <mat-error *ngIf="fnamee.errors?.required && isRegisterFormSubmitted ">
                                    Please enter your artist name
                                </mat-error>
                                <mat-error *ngIf="isRegisterFormSubmitted && fnamee.errors?.validSongTitle">
                                    Please enter a valid artist name
                                </mat-error>

                                <mat-error *ngIf="fnamee.errors?.pattern">
                                    Please enter a valid name.
                                </mat-error>

                                <mat-error
                                    *ngIf="isRegisterFormSubmitted && fnamee.errors?.maxlength && !fnamee.errors?.validSongTitle && !fnamee.errors?.required">
                                    Artist name can't be more than 50
                                    characters long.
                                </mat-error>


                            </div>


                        </div>


                        <div class="margin-flex ">
                            <div class="m-0 p-0 form-group" style="width: 100%;">
                                <div class="labels">User Name*</div>
                                <input class="m-0 form-control" id='username' (keyup)="checkUsername()"
                                    placeholder="Enter User Name" (change)="checkUsername()" type='text'
                                    formControlName="username"
                                    [ngClass]="{ 'is-invalid': (username.errors?.required || username.errors?.validSongTitle ||username.errors?.maxlength || username.errors?.minlength  ) && isRegisterFormSubmitted  ||username.errors?.usernameExists }"
                                    required>
                                <mat-error *ngIf="username.errors?.required  && isRegisterFormSubmitted ">
                                    Please enter a username
                                </mat-error>
                                <mat-error
                                    *ngIf="isRegisterFormSubmitted &&  username.errors?.validSongTitle && !username.errors?.required ">
                                    Please enter a valid username
                                </mat-error>
                                <mat-error *ngIf="username.errors?.minlength && !username.errors?.validSongTitle">
                                    Username must be atleast 3 characters long
                                </mat-error>
                                <mat-error *ngIf="username.errors?.maxlength && !username.errors?.validSongTitle">
                                    Username can't be more than 50 characters long
                                </mat-error>
                                <mat-error
                                    *ngIf="!username.errors?.required && !username.errors?.validSongTitle && !username.errors?.maxlength && !username.errors?.minlength && username.dirty && username.errors?.usernameExists && isUsernameExist">
                                    The username entered already exist
                                </mat-error>
                            </div>
                            <div (click)="suggestionFill(suggestion)" class='pointer suggestion-text' *ngIf="!username.errors?.required
                                && !username.errors?.maxlength && !username.errors?.minlength && username.dirty &&
                                isUsernameExist && suggestion!=''">
                                Suggestion: {{suggestion}}
                            </div>
                        </div>


                        <div class="margin-flex">
                            <div class="m-0 p-0 form-group" style="width: 100%;">
                                <div class="labels">Mobile Number</div>
                                <input class="m-0 form-control" type='tel' formControlName="mobile"
                                    placeholder="Mobile Number" (keypress)="keyPressNumbers($event)"
                                    [ngClass]="{ 'is-invalid':mobile.errors?.validMobile && mobile.errors?.dirty || mobile.errors?.maxlength || mobile.errors?.pattern}">
                                <mat-error *ngIf="mobile.errors?.pattern ||  mobile.errors?.maxlength ">
                                    Please enter a valid mobile number
                                </mat-error>

                            </div>
                        </div>


                        <div style="margin-bottom: 12px">
                            <div class="m-0 p-0 form-group " style="width: 100%;">
                                <div class="labels">Email*</div>
                                <input class="m-0 form-control" id='email' (keyup)="resetEmailErrors()" type='email'
                                    formControlName="email" placeholder="Your Email"
                                    [ngClass]="{ 'is-invalid': isRegisterFormSubmitted && email.errors?.required || (email.errors?.email ||email.errors?.pattern || email.errors?.emailExists || email.errors?.invalidEmail ) }"
                                    [readonly]="register.update && register.email!='' && register.email!=null && register.email!=undefined"
                                    required>

                                <mat-error *ngIf="isRegisterFormSubmitted &&  email.errors?.required ">
                                    Please enter your email ID
                                </mat-error>
                                <mat-error *ngIf="  email.errors?.email">
                                    Please enter a valid email ID
                                </mat-error>
                                <mat-error *ngIf=" !email.errors?.email && email.errors?.pattern">
                                    Please enter a valid email ID
                                </mat-error>
                                <mat-error
                                    *ngIf="!email.errors?.required  && !email.errors?.email && !email.errors?.pattern && email.errors?.emailExists">
                                    The Email ID entered already exist
                                </mat-error>
                                <mat-error
                                    *ngIf="!email.errors?.required  && !email.errors?.email && !email.errors?.pattern && email.errors?.invalidEmail">
                                    Invalid Email Address
                                </mat-error>
                            </div>
                        </div>

                        <div class="tc" sty>
                            By Signing Up, you agree to the <a routerLink="/about/terms-of-use"
                                target="_blank">terms&conditions</a> and <a routerLink="/about/privacy-policy"
                                target="_blank">privacy policy</a> of Songdew
                        </div>

                        <div class=" re-captcha-box">
                            <div class="re-captcha">
                                <re-captcha formControlName="recaptchaReactive"></re-captcha>
                            </div>
                            <mat-error
                                *ngIf="isRegisterFormSubmitted && recaptchaError && recaptchaReactive.errors?.required">
                                Please prove that you're not a robot
                            </mat-error>
                        </div>


                        <div class="text-center">
                            <button type="submit" class="submitbutton m-t-20"
                                (click)="global.ga4Event( 'registration', 'second_form','', 'manual',data.userLastClickFrom);"
                                [disabled]=buttonclicked>{{(buttonclicked)?'Submitting':CTALabel}}</button>
                        </div>


                    </div>
                </div>
            </form>
        </div>


        <!--City: PAGE 2-->
        <div class="city" id="form2" class="artistdetail" id="form2" *ngIf="formSteps==2">
            <form [formGroup]="cityForm" (ngSubmit)="onCityFormSubmit()" autocomplete="off">
                <div class="city" id="form3">
                    <div class="header">Where are you based?</div>
                    <div class="desc text-center">It will help you to get discovered when people are looking for artists
                        from a
                        particular area/city</div>
                    <div class="details1 custom-form ">
                        <div class="form-group">
                            <div class="labels l2">Country</div>
                            <input type="text" formControlName="country" class="form-control pointer icon-rtl"
                                autocomplete="off" readonly value="{{CountryValue}}"
                                [ngClass]="{'is-invalid':country.touched && country.errors?.required}"
                                placeholder="Your Country" id="Country" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">


                            <div style="position: absolute;top: -54px;width: 100%;left: 0px;">
                                <div class="dropdown-menu " aria-labelledby="Country" id="manualdrop">
                                    <img src="assets/images/sd-chevron-up.svg"
                                        style="position: absolute; right: 0px; margin-right: 10px; margin-top: 12px !important;">
                                    <input class="w-full border-0" type="text" [(ngModel)]="searchCountry"
                                        [ngModelOptions]="{standalone: true}" style="background-color: #f9f9f9;
                                        padding: 5px 10px;
                                        font-size: 12px;
                                        height: 30px;
                                        border-radius: 5px;" placeholder="Search ...">

                                    <div *ngFor="let country of countries | searchFilter:searchCountry">
                                        <a class="dropdown-item" (click)="dropvalueValidate('CountryValue',country)">
                                            <span>{{ country.name }}</span>
                                        </a>
                                    </div>
                                </div>

                            </div>
                            <mat-error *ngIf="country.touched && country.errors?.required"> Please select your
                                country</mat-error>
                        </div>




                        <div class="form-group">
                            <div class="labels l2">State</div>
                            <input type="text" formControlName="state" class="form-control pointer icon-rtl"
                                autocomplete="off" readonly value="{{StateValue}}"
                                [ngClass]="{'is-invalid':isCityFormSubmitted && state.errors?.required}"
                                placeholder="Your State" id="State" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">


                            <div style="position: absolute;top: -54px;width: 100%;left: 0px;">
                                <div class="dropdown-menu " aria-labelledby="state" id="manualdrop">
                                    <img src="assets/images/sd-chevron-up.svg"
                                        style="position: absolute; right: 0px; margin-right: 10px; margin-top: 12px !important;">
                                    <input class="w-full border-0" type="text" [(ngModel)]="searchState"
                                        [ngModelOptions]="{standalone: true}" style="background-color: #f9f9f9;
                                        padding: 5px 10px;
                                        font-size: 12px;
                                        height: 30px;
                                        border-radius: 5px;" placeholder="Search ...">
                                    <div *ngFor="let state of states | searchFilter:searchState">
                                        <a class="dropdown-item" (click)="dropvalueValidate('StateValue',state)">
                                            <span>{{ state.name }}</span>
                                        </a>
                                    </div>

                                </div>

                            </div>
                            <mat-error *ngIf="isCityFormSubmitted && state.errors?.required">Please select your state
                            </mat-error>
                        </div>


                        <div class="form-group">
                            <div class="labels l2">City</div>
                            <input type="text" formControlName="city" class="form-control pointer icon-rtl"
                                autocomplete="off" readonly value="{{CityValue}}"
                                [ngClass]="{'is-invalid':isCityFormSubmitted && city.errors?.required}"
                                placeholder="Your City" id="city" data-toggle="dropdown" aria-haspopup="true"
                                aria-expanded="false">


                            <div style="position: absolute;top:-10px;width: 100%;left: 0px;"
                                [ngStyle]="{'top':global.isMobile() ? '-5px':'-10px' }">
                                <div class="dropdown-menu" aria-labelledby="city" id="manualdrop">
                                    <img src="assets/images/sd-chevron-up.svg"
                                        style="position: absolute; right: 0px; margin-right: 10px; margin-top: 12px !important;">
                                    <input class="w-full border-0" type="text" [(ngModel)]="searchCity"
                                        [ngModelOptions]="{standalone: true}" style="background-color: #f9f9f9;
                                        padding: 5px 10px; 
                                        font-size: 12px;
                                        height: 30px;
                                        border-radius: 5px;" placeholder="Search ...">
                                    <div *ngFor="let city of cities | searchFilter:searchCity">
                                        <a class="dropdown-item" (click)="dropvalueValidate('CityValue',city.name)">
                                            <span>{{ city.name }}</span>
                                        </a>
                                    </div>

                                </div>

                            </div>
                            <mat-error *ngIf="isCityFormSubmitted && city.errors?.required"> Please select your city
                            </mat-error>
                        </div>

                        <div class="form-group" *ngIf="cityForm.value.city=='Other'">
                            <input type="text" class="form-control"
                                [ngClass]="{'is-invalid-control':isCityFormSubmitted && otherCity.errors?.required || otherCity.errors?.pattern}"
                                formControlName="otherCity" placeholder="Enter Your City">
                            <mat-error *ngIf="isCityFormSubmitted && otherCity.errors?.required"> Please enter your city
                            </mat-error>
                            <mat-error *ngIf="isCityFormSubmitted && otherCity.errors?.pattern"> Please enter valid city
                                name </mat-error>

                        </div>

                    </div>
                    <div class="text-center">
                        <button type="submit"
                            
                            class="submitbutton m-t-20"
                            [disabled]='buttonclicked'>{{(buttonclicked)?'Submitting':CTALabel}}</button>
                    </div>
                    <!--div class="skip pointer">
                        <a (click)='global.trackEvent("Registration", "Skip", "form2");skip()' style="padding:0; margin:0;border:0;background-color:transparent;">
                            Skip <img src="../../assets/images/skip.svg" alt="">
                        </a>
                    </div-->

                </div>


            </form>
        </div>


        <!--Song pref: PAGE 3-->
        <div class="artistdetail" id="form3" *ngIf="formSteps==3 && showForm3">
            <form [formGroup]="artistTypeForm" (ngSubmit)="onArtistTypeFormSubmit()">
                <div class="songdetail" id="form3">
                    <div class="header">Great, tell us bit more about you</div>
                    <div class="notartist p-b-10 border-bottom">It will help us to customise our offering to you
                    </div>
                    <br>
                    <div class="subhead">How will you describe your Skills/Areas of Interest?</div>
                    <div class="notartist1 tabdiv">You may choose max of
                        three options</div>
                    <mat-error class="f12 m-b-10" *ngIf="isartistFormSubmitted==true && selectedArtistType.length<1">
                        Please choose atleast one option.</mat-error>
                    <mat-error class="f12 m-b-10" *ngIf="checkboxError">You can only select 3</mat-error>
                    <div class="checkbox-container m-t-5">
                        <ng-container class="checkk" *ngFor="let type of artistTypes">
                            <div>
                                <div class="m-0 col-xs-6 p-0 f12 check-W">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" [value]="type"
                                            (change)="onCheckboxChange($event, type)">
                                        <label class="form-check-label">{{type}}</label>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <div class="text-center">
                        <button type="submit" class="submitbutton m-t-20"
                        
                            [disabled]="buttonclicked">{{(buttonclicked)?'Submitting':CTALabel}}</button>
                    </div>

                    <!--div class="skip pointer">
                        <a (click)='global.trackEvent("Registration", "Skip", "form3");skip();closeDialog();verifyEmail()' 
                            style="padding:0; margin:0;border:0;background-color:transparent; color: black !important">
                            Skip <img src="../../assets/images/skip.svg">
                        </a>
                    </div-->

                </div>


            </form>
        </div>


        <!--Listener Details-->
        <div class="listdetail" id="form4" *ngIf="formSteps==4">
            <form [formGroup]="listenerForm" (ngSubmit)="onlistenerFormSubmit()">
                <div class="listdetail" id="form4">
                    <div class="header m-b-0">Add Your Details As Listener</div>
                    <div class="notartist" style="margin-bottom:28px;">Are you an Artist?
                        <a (click)="artist()">Click here</a>
                    </div>


                    <div class="details2">
                        <div class="margin-flex">
                            <div class="m-0 p-0 form-group" style="width: 100%;">
                                <div class="labels">First Name*</div>
                                <input class="m-0 form-control" type='text' formControlName="fname" required
                                    placeholder="Your First Name"
                                    [ngClass]="{ 'is-invalid': isListenerFormSubmitted && fname.errors  }">
                                <mat-error *ngIf="isListenerFormSubmitted && fname.errors?.required">
                                    Please enter your First Name
                                </mat-error>
                                <mat-error
                                    *ngIf=" isListenerFormSubmitted && !fname.errors?.required && fname.errors?.validSongTitle">
                                    Please enter a valid First Name
                                </mat-error>
                                <mat-error
                                    *ngIf="isListenerFormSubmitted && fname.errors?.minlength && !fname.errors?.validSongTitle && !fname.errors?.required">
                                    First Name must be atleast 1 character long
                                </mat-error>
                                <mat-error
                                    *ngIf="isListenerFormSubmitted && fname.errors?.maxlength && !fname.errors?.validSongTitle && !fname.errors?.required">
                                    First Name can't be more than 50 characters long
                                </mat-error>
                            </div>
                        </div>



                        <div style="margin-bottom:16px">
                            <div class="m-0 p-0 form-group" style="width: 100%;">
                                <div class="labels">Last Name</div>
                                <input class="m-0 form-control" type='text' formControlName="lname"
                                    placeholder="Your Last Name">
                                <mat-error *ngIf="isListenerFormSubmitted && lname.errors?.maxlength">
                                    Last name can't be more than 50 characters long
                                </mat-error>
                            </div>

                        </div>

                        <div style="margin-bottom:16px">
                            <div class="m-0 p-0 form-group" style="width: 100%;">
                                <div class="labels">Email</div>
                                <input class="m-0 form-control" id='email' (keyup)="resetEmailErrors()" type='email'
                                    formControlName="email" placeholder="Your Email"
                                    [ngClass]="{ 'is-invalid': email.errors  }"
                                    [readonly]="register.update && register.listenerEmail!='' && register.listenerEmail!=null && register.listenerEmail!=undefined"
                                    required>
                                <mat-error *ngIf="listenerEmail.errors?.required">
                                    Please enter your email ID
                                </mat-error>
                                <mat-error
                                    *ngIf="!listenerEmail.errors?.required && listenerEmail.dirty && listenerEmail.errors?.listenerEmail">
                                    Please enter a valid email ID
                                </mat-error>
                                <mat-error
                                    *ngIf="!listenerEmail.errors?.required && listenerEmail.dirty && !listenerEmail.errors?.listenerEmail && listenerEmail.errors?.pattern">
                                    Please enter a valid email ID
                                </mat-error>
                                <mat-error
                                    *ngIf="!listenerEmail.errors?.required && listenerEmail.dirty && !listenerEmail.errors?.listenerEmail && !listenerEmail.errors?.pattern && listenerEmail.errors?.emailExists">
                                    The Email ID entered already exist
                                </mat-error>
                                 <mat-error
                                    *ngIf="!listenerEmail.errors?.required && listenerEmail.dirty && !listenerEmail.errors?.listenerEmail && !listenerEmail.errors?.pattern && listenerEmail.errors?.invalidEmail">
                                    Invalid Email Address
                                </mat-error>
                            </div>
                        </div>

                        <div class="tc" sty>
                            By Signing Up, you agree to the <a routerLink="/about/terms-of-use"
                                target="_blank">terms&conditions</a> and <a routerLink="/about/privacy-policy"
                                target="_blank">privacy policy</a> of Songdew
                        </div>

                        <div class="re-captcha-box">
                            <div class="re-captcha">
                                <re-captcha formControlName="recaptchaReactive"></re-captcha>
                            </div>
                            <mat-error
                                *ngIf="isListenerFormSubmitted && listernRecaptchaError && listenerRecaptchaReactive.errors?.required">
                                Please prove that you're not a robot
                            </mat-error>
                        </div>

                    </div>
                    <div class="text-center">
                        <button type="submit"
                       
                            class="submitbutton m-t-20"
                            [disabled]=buttonclicked>{{(buttonclicked)?'Submitting':CTALabel}}</button>
                    </div>



                </div>
            </form>
        </div>




    </div>
</div>
